import React from "react";
import LandingFeatures from "./LandingFeatures";
import LandingFooter from "./LandingFooter";
import LandingHeader from "./LandingHeader";
import LandingHero from "./LandingHero";
import LandingHowItWorks from "./LandingHowItWorks";
import LandingWaitingListModal from "./LandingWaitingListModal";

// --- Page ---
const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#eae6df] text-[#2f2f2d]">
      <LandingHeader />

      {/* Hero */}
      <LandingHero />

      {/* Features */}
      <LandingFeatures />

      {/* How it works (3-step) */}
      <LandingHowItWorks />

      {/* FAQ */}
      <section id="faq" className="mx-auto max-w-6xl px-5 py-16">
        <div className="rounded-3xl bg-white/90 p-8 shadow-2xl">
          <h2 className="text-2xl font-bold text-[#2f2f2d]">FAQ</h2>
          <div className="mt-6 space-y-4">
            <details className="group rounded-xl border border-gray-200 p-4">
              <summary className="cursor-pointer list-none font-semibold text-[#2f2f2d]">Who's this software for?</summary>
              <p className="mt-2 text-sm text-[#2f2f2d]">InkVoyd is for all independent artists. From artists just starting out to seasoned professionals with their own internal teams that have to navigate the complexities of their craft. This software brings together all of the tools and resources needed to succeed in one convenient platform.</p>
            </details>
            <details className="group rounded-xl border border-gray-200 p-4">
              <summary className="cursor-pointer list-none font-semibold text-[#2f2f2d]">Is InkVoyd for studios?</summary>
              <p className="mt-2 text-sm text-[#2f2f2d]">No, InkVoyd is designed specifically for independent artists and their unique needs.</p>
            </details>
            <details className="group rounded-xl border border-gray-200 p-4">
              <summary className="cursor-pointer list-none font-semibold text-[#2f2f2d]">I have my own website, can I still use InkVoyd?</summary>
              <p className="mt-2 text-sm text-[#2f2f2d]">This is still in the works, but our software is an API which means your website will be able to integrate our features.</p>
            </details>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="mx-auto max-w-6xl px-5 pb-20">
        <div className="rounded-3xl bg-white/90 p-8 text-center shadow-2xl">
          <h2 className="text-2xl font-bold text-[#2f2f2d]">Ready to streamline your bookings?</h2>
          <p className="mt-1 text-[#2f2f2d]">
            Join the waiting list and get back to the part of the job you love.
          </p>
          <div className="mt-4 flex justify-center">
            <LandingWaitingListModal
              title="Join the InkVoyd waiting list"
              buttonText="Get started"
            />
          </div>
        </div>
      </section>

      <LandingFooter />
    </div>
  );
};

export default LandingPage;